module.exports = __webpack_public_path__ + "img/SL7_4849-Bearbeitet.b2e5fdef.jpg";